<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon cf-dlg-icon--blue"><mat-icon>sync</mat-icon></div>
    <div>
      <h2 class="cf-dlg-title">Tarjeta ya existente</h2>
      <p class="cf-dlg-subtitle">{{ dataImport?.number }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="importing" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="importing" message="Añadiendo asientos…"></app-loading-state>

  <ng-container *ngIf="!importing">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch" *ngIf="error">
        <mat-icon>error</mat-icon>
        <span>{{ error }}</span>
      </div>
      <p>El número de tarjeta coincide con una tarjeta ya registrada en Handly. ¿Quieres añadir los asientos contables a la tarjeta existente?</p>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="startImport()">
        <mat-icon>sync</mat-icon> Sí, añadir asientos
      </button>
    </div>
  </ng-container>
</div>
